import Login from './Login'
import './Auth.css'

/**
 * LoginPage wrapper component for consistent naming with App routing
 * Re-exports the main Login component
 */
function LoginPage() {
  return <Login />
}

export default LoginPage
